import { centsToDollarString } from '../misc';

export default function googlePayItemFromPurchase(
  purchase: PurchaseWithTotals,
  currency_code: string,
): GooglePayItem {
  const unitPrice = purchase.discountedMoneyPrice / purchase.quantity;

  return {
    currency_code: currency_code,
    description: purchase?.item?.name || 'Item',
    unit_price: centsToDollarString(unitPrice),
    total_price: centsToDollarString(purchase.discountedMoneyPrice),
    quantity: String(purchase.quantity || 1),
  };
}
